import { Link } from "react-router-dom";

interface Crumb {
  label: string;
  path?: string;
}

export default function PageHero({
  crumbs,
  title,
  subtitle,
  badge,
}: {
  crumbs: Crumb[];
  title: string;
  subtitle: string;
  badge?: string;
}) {
  return (
    <section className="bg-gradient-to-b from-primary-100/70 to-background-50 pt-24 md:pt-28 pb-10 md:pb-14">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <nav className="flex flex-wrap items-center gap-2 text-sm text-foreground-600" aria-label="面包屑">
          {crumbs.map((c, i) => (
            <span key={c.label} className="flex items-center gap-2">
              {c.path ? (
                <Link to={c.path} className="hover:text-primary-600">
                  {c.label}
                </Link>
              ) : (
                <span className="text-foreground-800">{c.label}</span>
              )}
              {i < crumbs.length - 1 && <i className="ri-arrow-right-s-line text-foreground-400" />}
            </span>
          ))}
        </nav>
        <div className="mt-5 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div>
            {badge && (
              <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-800">
                <i className="ri-sparkling-2-line" />
                {badge}
              </span>
            )}
            <h1 className="mt-3 font-display text-3xl text-foreground-950 md:text-5xl">{title}</h1>
          </div>
        </div>
        <p className="mt-3 max-w-2xl text-sm leading-6 text-foreground-700 md:text-base">{subtitle}</p>
      </div>
    </section>
  );
}